import fuzzy from 'fuzzy';

const getRestrictedSchoolFilter = response => {
  const { data } = response;

  const searchable = data.length > 10;
  return {
    key: 'schools',
    source: 'schools',
    filterName: 'Schools',
    searchable,
    defaultSelection: data,
    options: data,
    selector: 'id',
    label: 'name',
    search: searchTerm => {
      const results = searchTerm
        ? data.filter(({ name }) => fuzzy.match(searchTerm, name))
        : data;
      return results;
    },
    infiniteScroll: searchable,
    searchOnOpen: searchable,
  };
};

export default getRestrictedSchoolFilter;
